'use client';

import { useState } from 'react';

function BrokerLogo({
    broker,
    logoUrl,
    size = 16,
    borderColor,
    rounded = 'full',
    className = '',
}: {
    // Display name (or code) - used for alt text and the fallback initial.
    broker: string;
    logoUrl?: string;
    size?: number;
    // When set, the logo carries this color as a ring - used to tie it back
    // to the broker's chart/series color without a separate dash indicator.
    borderColor?: string;
    rounded?: 'full' | 'md';
    className?: string;
}) {
    const [failed, setFailed] = useState(false);

    const borderStyle = borderColor ? { borderColor, borderWidth: 2, borderStyle: 'solid' as const } : undefined;
    const borderClass = borderColor ? 'p-[1px]' : '';
    const roundedClass = rounded === 'full' ? 'rounded-full' : 'rounded-[3px]';

    if (failed || !logoUrl) {
        return (
            <span
                role='img'
                aria-label={`${broker} logo`}
                className={`inline-flex shrink-0 items-center justify-center bg-slate-200 font-semibold text-slate-500 ${roundedClass} ${borderClass} ${className}`}
                style={{ width: size, height: size, fontSize: size * 0.5, ...borderStyle }}>
                {broker.charAt(0).toUpperCase()}
            </span>
        );
    }

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={logoUrl}
            alt={`${broker} logo`}
            width={size}
            height={size}
            className={`shrink-0 object-contain ${roundedClass} ${borderClass} ${className}`}
            style={borderStyle}
            onError={() => setFailed(true)}
        />
    );
}

export default BrokerLogo;
